import React from "react";

export type TagSelectorContextValue = {
  createNewTag?: () => void;
  loadMoreLoading?: boolean;
  allowCreateNewTag?: boolean;
};

export const SelectorContext = React.createContext<TagSelectorContextValue>({});
